import React, { useEffect, useState } from "react";

type ModalProps = {
  show: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

const Modal: React.FC<ModalProps> = ({ show, onClose, children }) => {
  const [visible, setVisible] = useState(show);
  const [animateIn, setAnimateIn] = useState(false);

  // ESC key handler
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (show) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [show, onClose]);

  // Trigger slide-in once when shown
  useEffect(() => {
    if (show) {
      // 1. Mount modal
      setVisible(true);

      // 2. Ensure it starts in "closed" state
      setAnimateIn(false);

      // 3. On next frame, trigger "open" animation
      requestAnimationFrame(() => {
        setAnimateIn(true);
      });

    } else if (visible) {
      // Closing animation
      setAnimateIn(false);

      const timer = setTimeout(() => {
        setVisible(false);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [show, visible]);

  if (!show && !visible) return null;

  return (
    <>
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1040 }}
        onClick={onClose}
      />
      <div
        className="modal d-block"
        style={{ zIndex: 1050 }}
        onClick={onClose}
      >
        <div
          className={`modal-dialog modal-dialog-centered custom-modal-dialog steam-modal-dialog ${animateIn ? "steam-modal-dialog--open" : ""
            }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content custom-modal-box">
            <div className="modal-body">{children}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
